import RequiresPrintPackageAlertModal, {
  REQUIRES_PRINT_PACKAGE_ALERT_MODAL,
} from './modal';

export { REQUIRES_PRINT_PACKAGE_ALERT_MODAL };

export default RequiresPrintPackageAlertModal;
